
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AthleteAutocompleteInfo } from '@best-athletes/ba-types';
@Component
export default class AthletePreview extends Vue{
	@Prop({ required: true }) value: AthleteAutocompleteInfo;
}
